import { render, staticRenderFns } from "./DadosOrganizacao.vue?vue&type=template&id=0ce08c20&scoped=true"
import script from "./DadosOrganizacao.vue?vue&type=script&lang=js"
export * from "./DadosOrganizacao.vue?vue&type=script&lang=js"
import style0 from "./DadosOrganizacao.vue?vue&type=style&index=0&id=0ce08c20&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ce08c20",
  null
  
)

export default component.exports